import { appRoute } from "@/components/routes/app-route";
import { DEFAULT_ACCESSIBLE_FILTER_STATE, DEFAULT_COUNTY_FILTER_STATE, DEFAULT_DISSOLVE_FILTER_STATE } from "@/config/site";

export function useAppFilter() {
    const filters = appRoute.useSearch({ select: s => s.f });

    return {
        isCountyFilterEnabled: typeof filters?.counties === 'undefined' ? DEFAULT_COUNTY_FILTER_STATE : filters.counties,
        isAccessibilityLayerFilterEnabled: typeof filters?.accessibility === 'undefined' ? DEFAULT_ACCESSIBLE_FILTER_STATE : filters.accessibility,
        isDissolveEnabled: typeof filters?.dissolve === 'undefined' ? DEFAULT_DISSOLVE_FILTER_STATE : filters.dissolve,
        ...filters
    }
}
